<button class="btn btn-paypal btn-block svg-primary" [disabled]="disableBtn">
    <img src="https://cdn.watchcorridor.com/assets/PayPal.svg" alt="Pay with PayPal" />
</button>